<template>
  <div class="onboarding-block-wrapper flex">
    <img class="avatar" src="https://logo.wondercv.com/banners/rFXnEYEDDxKYuKX.png" alt="" />
    <div class="onboarding-block-container">
      <div class="title">我们将根据你填写的信息生成专属简历，信息越详细生成的简历会越准确哦~</div>
      <ProgressBar :percentage="percentage" />
    </div>
  </div>
</template>
<script>
import ProgressBar from './ProgressBar.vue'
export default {
  name: 'AiResumeProgress',
  components: {
    ProgressBar,
  },
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../styles/index.scss';
.onboarding-block-wrapper {
  .onboarding-block-container {
    width: 622px;
    .title {
      font-size: 16px;
      color: #fff;
      margin-bottom: 20px;
    }
    .progress-bar {
      width: 580px;
    }
  }
}
</style>